import React, { useState } from 'react';

import { Sheet } from '@pkg/components';

import { type NFTManagerQueryType } from '../../hooks';

import { FilterHeader, ManagerGrid } from './components';
import { FilterSidebar } from './components/FilterSidebar';
import { type NftCardProps } from './components/ManagerGrid/components';

import { SheetLayout } from './styles';

export type SidePanelContentProps = Pick<
    NftCardProps,
    'handleAddItem' | 'handleIsSelected' | 'handleRemoveItem' | 'handleSelect' | 'handleIsDisabledPageItem'
> & {
    query: NFTManagerQueryType;
    onClose: () => void;
};

export function SidePanelContent({
    query,
    handleAddItem,
    handleRemoveItem,
    handleIsSelected,
    handleSelect,
    handleIsDisabledPageItem,
    onClose,
}: SidePanelContentProps) {
    const { data, isLoading, hasNextPage, fetchNextPage, isFetching } = query();
    const nftCards = data?.pages?.flatMap((page) => page.data);

    const total = data?.pages?.[0].paging.total || 0;

    const [showSidebar, setShowSidebar] = useState(false);
    const handleSidebarOpen = () => setShowSidebar(true);
    const handleSidebarClose = () => setShowSidebar(false);
    const handleSidebarToggle = () => setShowSidebar((open) => !open);

    return (
        <Sheet.Main key="SidePanelContent-Views">
            <SheetLayout>
                <FilterHeader onToggle={handleSidebarToggle} showSidebar={showSidebar} totalResults={total} />

                <Sheet.Layout.Columns stretch>
                    <Sheet.Layout.Columns.Primary padded scrollable>
                        <ManagerGrid
                            onClose={onClose}
                            handleIsSelected={handleIsSelected}
                            handleSelect={handleSelect}
                            handleAddItem={handleAddItem}
                            handleRemoveItem={handleRemoveItem}
                            fetchNextPage={fetchNextPage}
                            handleIsDisabledPageItem={handleIsDisabledPageItem}
                            hasNextPage={Boolean(hasNextPage)}
                            isLoading={isLoading || isFetching}
                            nftCards={nftCards}
                        />
                    </Sheet.Layout.Columns.Primary>

                    <FilterSidebar
                        handleSidebarClose={handleSidebarClose}
                        handleSidebarOpen={handleSidebarOpen}
                        handleSidebarToggle={handleSidebarToggle}
                        showSidebar={showSidebar}
                    />
                </Sheet.Layout.Columns>
            </SheetLayout>
        </Sheet.Main>
    );
}
